import React from "react";
import { useI18n } from "../lib/i18n";

export default function LanguageToggle({ className = "" }) {
  const { lang, setLang } = useI18n();
  return (
    <div className={`inline-flex items-center bg-bg-2 rounded-full p-1 border border-white/5 ${className}`} data-testid="lang-toggle">
      <button
        data-testid="lang-toggle-mn"
        onClick={() => setLang("mn")}
        className={`px-3 py-1 text-xs font-bold rounded-full transition ${lang === "mn" ? "bg-primary text-white shadow-glow" : "text-slate-400 hover:text-white"}`}
      >МН</button>
      <button
        data-testid="lang-toggle-en"
        onClick={() => setLang("en")}
        className={`px-3 py-1 text-xs font-bold rounded-full transition ${lang === "en" ? "bg-primary text-white shadow-glow" : "text-slate-400 hover:text-white"}`}
      >EN</button>
    </div>
  );
}
